import React from "react";
import { Modal, Table } from "antd";

export default function TotalInvoicesModal({ visible, data, onClose }) {
	const columns = [
		{
			title: "Do'kon",
			dataIndex: "whsName",
			key: "whsName",
			render: (text, record) => {
				return (
					<span className={`${text === "Umumiy" ? "font-extrabold" : ""}`}>
						{text === "Umumiy" ? "Umumiy Sotuvlar" : text}
					</span>
				);
			},
		},
		{
			title: "Sotuv summasi",
			dataIndex: "salesDocTotal",
			key: "salesDocTotal",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return (
					<span className={`${record?.whsName === "Umumiy" ? "font-extrabold" : ""}`}>
						{formattedText}
					</span>
				);
			},
		},
		{
			title: "Sotuvlar soni",
			dataIndex: "salesCount",
			key: "salesCount",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return (
					<span className={`${record?.whsName === "Umumiy" ? "font-extrabold" : ""}`}>
						{formattedText}
					</span>
				);
			},
		},
	];

	return (
		<Modal
			open={visible}
			onRequestClose={onClose}
			onCancel={onClose}
			style={{
				content: {
					top: "50%",
					left: "50%",
					right: "auto",
					bottom: "auto",
					marginRight: "-50%",
					transform: "translate(-50%, -50%)",
					borderRadius: "10px",
					border: "none",
					padding: "20px",
					backgroundColor: "white",
					outline: "none",
				},
				overlay: {
					background: "#0000008D",
				},
			}}
			contentLabel="Example Modal"
			ariaHideApp={false}
			footer={null}
		>
			<div className={"w-full"}>
				<Table columns={columns} dataSource={data} pagination={false} />
			</div>
		</Modal>
	);
}
